/* Anything Else You Need? - bucketed cart upsells.
   Reads bucket config emitted by sections/cart-upsells.liquid, finds the
   priciest bike in the cart, renders the first matching bucket's products
   as one-tap add rows in the cart drawer and on the cart page. */
(function () {
  var configEl = document.getElementById('cart-upsells-config');
  var root = document.getElementById('cart-upsells-root');
  if (!configEl || !root) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config.buckets || !config.buckets.length) return;

  var GROUPS = {
    road_tt: ['Road Bike', 'TT Bike'],
    gravel_cx: ['Gravel/CX Bike'],
    hybrid_mtb: ['MTB', 'Hybrid'],
  };
  var BIKE_TYPES = [].concat(GROUPS.road_tt, GROUPS.gravel_cx, GROUPS.hybrid_mtb);

  function money(cents) {
    var pounds = cents / 100;
    var whole = Math.floor(pounds);
    var grouped = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var pence = Math.round(cents % 100);
    return '£' + grouped + (pence ? '.' + (pence < 10 ? '0' : '') + pence : '');
  }

  function mountRoot() {
    // drawer first; else cart page below the cart section
    var drawerForm = document.querySelector('#site-cart-sidebar .sidebar__body .cart-form');
    if (drawerForm && root.parentElement !== drawerForm.parentElement) {
      drawerForm.parentElement.insertBefore(root, drawerForm.nextSibling);
      return;
    }
    var cartSection = document.querySelector('.cart-section');
    if (!drawerForm && cartSection && root.parentElement !== cartSection.parentElement) {
      cartSection.parentElement.insertBefore(root, cartSection.nextSibling);
    }
  }

  function pickBucket(cart) {
    var anchor = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (BIKE_TYPES.indexOf(it.product_type) === -1) continue;
      if (!anchor || it.price > anchor.price) anchor = it;
    }
    if (!anchor) return null;
    var pounds = anchor.price / 100;
    for (var b = 0; b < config.buckets.length; b++) {
      var bk = config.buckets[b];
      var types = GROUPS[bk.group];
      if (bk.group !== 'any' && (!types || types.indexOf(anchor.product_type) === -1)) continue;
      if (bk.min && pounds < bk.min) continue;
      if (bk.max && pounds >= bk.max) continue;
      return bk;
    }
    return null;
  }

  function render(cart) {
    mountRoot();
    var bucket = pickBucket(cart);
    if (!bucket) { root.hidden = true; return; }

    var inCart = cart.items.map(function (it) { return it.handle; });
    var cartTypes = cart.items.map(function (it) { return it.product_type; });
    // a bundle product covers its component categories
    if (cartTypes.indexOf('Bundle') !== -1 || cartTypes.indexOf('Bundles') !== -1) {
      cartTypes.push('Pedals', 'Bottle Cages');
    }
    // never upsell a product whose category is already in the cart -
    // pedals added means the pedal slots vanish and the cages surface
    var products = bucket.products.filter(function (p) {
      return inCart.indexOf(p.handle) === -1 && cartTypes.indexOf(p.ptype) === -1;
    }).slice(0, 2);
    if (!products.length) { root.hidden = true; return; }

    var html = '<p class="cart-upsells__heading">' + config.heading + '</p>';
    // pedal-specific nudge only while pedals are actually on offer
    var offeringPedals = products.some(function (p) { return p.ptype === 'Pedals'; });
    var nudge = offeringPedals ? config.nudge : config.nudgeAlt;
    if (config.showNudge && nudge) {
      html += '<p class="cart-upsells__nudge">' + nudge + '</p>';
    }
    html += '<div class="cart-upsells__grid">';
    products.forEach(function (p) {
      html +=
        '<div class="cart-upsells__card">' +
          '<a class="cart-upsells__img" href="' + p.url + '" tabindex="-1">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="cart-upsells__title" href="' + p.url + '">' + p.title + '</a>' +
          '<span class="cart-upsells__foot">' +
            '<span class="cart-upsells__price">' + money(p.price) + '</span>' +
            '<button type="button" class="cart-upsells__add" data-variant-id="' + p.variantId + '" data-bucket="' + bucket.label + '">+ Add</button>' +
          '</span>' +
        '</div>';
    });
    html += '</div>';
    root.innerHTML = html;
    root.hidden = false;
  }

  /* Bundle cart lines get an "Includes:" note - contents come from the
     bundle-config section JSON (same source as the PDP bundle cards) */
  var bundleContents = null;
  var bundleNames = null;
  function bundleContentsMap() {
    if (bundleContents) return bundleContents;
    bundleContents = {};
    bundleNames = {};
    var el = document.getElementById('bundle-config');
    if (el) {
      try {
        (JSON.parse(el.textContent).bundles || []).forEach(function (b) {
          if (!b.bundleProduct) return;
          if (b.contents) bundleContents[b.bundleProduct.variantId] = b.contents;
          bundleNames[b.bundleProduct.variantId] = b.name;
        });
      } catch (e) {}
    }
    return bundleContents;
  }

  /* Order-level note: the Bundles app explodes bundle lines into
     components at order creation, burying line properties - a cart
     attribute lands in the order's Additional details intact. Synced
     from cart state so removing the bundle clears it. */
  function syncBundleAttribute(cart) {
    bundleContentsMap();
    var names = [];
    cart.items.forEach(function (item) {
      if (bundleNames[item.id]) names.push(bundleNames[item.id]);
      else if (item.product_type === 'Bundle' || item.product_type === 'Bundles') names.push(item.product_title);
    });
    var desired = names.join(', ');
    var current = (cart.attributes && cart.attributes.Bundle) || '';
    if (desired === current) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Bundle: desired } }),
    }).catch(function () {});
  }

  function annotateBundles(cart) {
    var map = bundleContentsMap();
    cart.items.forEach(function (item) {
      var contents = map[item.id];
      if (!contents && item.product_type !== 'Bundle' && item.product_type !== 'Bundles') return;
      if (!contents) return;
      document.querySelectorAll('[data-js-cart-item][data-id="' + item.key + '"]').forEach(function (el) {
        if (el.querySelector('.cart-bundle-contents')) return;
        var note = document.createElement('div');
        note.className = 'cart-bundle-contents';
        note.textContent = 'Includes: ' + contents;
        var actions = el.querySelector('.cart-item__actions');
        if (actions) actions.parentElement.insertBefore(note, actions);
        else el.appendChild(note);
      });
    });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        annotateBundles(cart);
        syncBundleAttribute(cart);
      })
      .catch(function () {});
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-upsells__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(btn.getAttribute('data-variant-id'), 10),
          quantity: 1,
          properties: { _added_from: 'cart-upsell:' + btn.getAttribute('data-bucket') },
        }],
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Added ✓';
        if (window.refreshCart) window.refreshCart();
        setTimeout(refresh, 600);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Add';
      });
  });

  // re-evaluate when the theme's ajax cart re-renders (qty changes, removals)
  var debounceTimer = null;
  function watchCartForm() {
    var target = document.querySelector('#site-cart-sidebar .cart-form') || document.querySelector('.cart-section');
    if (!target) return;
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refresh, 400);
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    watchCartForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
